
import LogoutAvatar from "../components/common/logout-avatar.vue";
import logo from "assets/images/logo.png";
export default {
  components: { LogoutAvatar },
  data() {
    return {
      logo
    };
  }
};
